import React, {useState, useEffect} from 'react'
import EtUserPicUploadInline from '@/features/users/EtUserPicUploadInline'
import EtTrinityWebAdmin from './EtTrinityWebAdmin'

import PulseLoader from "react-spinners/PulseLoader" // 12 May 2025
import EtBtnFormBasic from "@/components/common/buttons/EtBtnFormBasic" // 12 May 2025
import { PlusIcon, MinusIcon, TrashIcon, PencilSquareIcon,  } from '@heroicons/react/24/outline'
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/solid"

import { useGetUsersQuery, useUpdateUserMutation } from "@/features/users/usersApiSlice" // 12 May 2025


import entityMap from '@/data/admin/entityMap';
import {
    adminMenuItems, 
    orgAdminMenuItems, 
    userAdminMenuItems, 
    userAdminImprintMenuItems,
    orgLeaderAdminMenuItems,    // 26 Jun 2026
    orgIgniterMenuItems,          // 08 Sep 2026
} from '@/data/admin/adminMenuItems';
import entityNameMap from "@/data/admin/entityNameMap";

// 09 May 2025
import EtTrinityUserPacks from './EtTrinityUserPacks'

const EtTrinityUserProfile = ({userOrgId="", userId="", profileInfo={}}) => {
  
  // First Created - 06 May 2025
  // Author - Atul Pandey
  // Updated - 09 May 2025 - Added Subscription Pack Info
  // Updated - 11 May 2025 - Added User 360 Imprint - Et
  // Updated - 12 May 2025 - For refining user key info updates
  // Updated - 06 Jun 2025 - Moved the userAdminImprintMenuItems to isAdmin (EtAdmin section)
  // Updated - 29 Aug 2025 - Refined for googleDocsEnabled flag
  // Updated - 08 Sep 2025 - Refined for  orgIgniterMenuItems

//   console.log('profileInfo', profileInfo)

  // 1 - Set State Variables
  const [activeMenuItem, setActiveMenuItem] = useState("profile");
  const [activeAdminView, setActiveAdminView] = useState("actionTypes"); // 👈 11 May 2025 NEW from Admin Page
  const [selectedEntityId, setSelectedEntityId] = useState(null);        // 👈 11 May 2025 NEW from Admin Page
  const [editMode, setEditMode] = useState(false); // 👈 12 May 2025
  const [feedbackMessage, setFeedbackMessage] = useState(null); // 👈 12 May 2025 string | null
  const [feedbackType, setFeedbackType] = useState(null);       // 👈 12 May 2025 "success" | "error" | null
  const [isIcalVisible, setIsIcalVisible] = useState(false); // 👈 12 May 2025 ✅ Toggle visibility

  
  // 2a - Build My Details data:
  const username = profileInfo.username
//   const name = profileInfo.name
  const isAdmin = profileInfo.isAdmin
  const isOrgAdmin = profileInfo.isOrgAdmin
  const isOrgLeader = profileInfo.isOrgLeader   // 26 Jun 2026
  const isOrgIgniter = profileInfo.isOrgIgniter   // 08 Sep 2026

  // 2b - Get complete user data - 12 May 2025
  const { data: usersData } = useGetUsersQuery();
  const fullUserInfo = usersData?.ids
  ?.map(id => usersData.entities[id])
  ?.find(user => user?.username === username);

//   console.log('fullUserInfo',fullUserInfo)

  // 2c - Create FormData for the User Profile - 12 May 2025
  const [formData, setFormData] = useState({
    name: fullUserInfo?.name || "",
    email: fullUserInfo?.email || "",
    username: fullUserInfo?.username || "",
    googleIcalUrl: fullUserInfo?.googleIcalUrl || "",

    // 29 Aug 2026
    googleDocsEnabled:
    !!fullUserInfo?.googleDocsEnabled,
  });

  // 2d - Define the mutation to update the user - 12 May 2025
  const [updateUser, { isLoading: isUpdating, isSuccess: isUpdateSuccess, isError: isUpdateError, error: updateError  }] = useUpdateUserMutation()
  
  // 2e - Dirty Check - check of the user info has changed from the original
  const isDirty =
  formData.name !== (fullUserInfo?.name || "") ||
  formData.email !== (fullUserInfo?.email || "") ||
  formData.username !== (fullUserInfo?.username || "") ||
  formData.googleIcalUrl !== (fullUserInfo?.googleIcalUrl || "") ||
  formData.googleDocsEnabled !== !!fullUserInfo?.googleDocsEnabled; // 29 Aug 2026

  // 2f - Reset feedbackMessage
  useEffect(() => {
    if (feedbackMessage) {
      const timer = setTimeout(() => {
        setFeedbackMessage(null);
        setFeedbackType(null);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [feedbackMessage]);


  // 3 - Get entity type
    const getEntityType = (activeAdminView) => {
      return Object.keys(entityNameMap)
      .sort((a, b) => b.length - a.length) // Sort by length DESCENDING
      .find(type => 
          entityNameMap[type].some(name => 
              activeAdminView.toLowerCase().includes(name.toLowerCase())
          )
      ) || null;
    };
  
  // 4 - Render the corresponding component dynamically
  const renderAdminContent = () => {
    // const entityType = Object.keys(entityMap).find(type => activeAdminView.includes(type));
    const entityType = getEntityType(activeAdminView);

    // console.log(
    //         'activeAdminView',
    //         activeAdminView
    //     )

    // console.log('entityType', entityType)


    if (entityType) {
        const action = activeAdminView.replace(new RegExp(entityType, "i"), "").toLowerCase().trim();
        
        
        // 14 Oct 2026
        let Component = null

        if (
            action === ""
        ) {

            Component =
                entityMap[
                    entityType
                ]?.list

        } else {

            Component =
                entityMap[
                    entityType
                ]?.[
                    action
                ]

        }

        if (
            !Component
        ) {

            console.error(
                "Admin component not found",
                {
                    activeAdminView,
                    entityType,
                    action,
                    entityConfig:
                        entityMap[
                            entityType
                        ],
                }
            )


            return (
                <div
                    className="text-sm text-red-600"
                >
                    Admin component not configured for{" "}
                    <span
                        className="font-bold"
                    >
                        {activeAdminView}
                    </span>
                </div>
            )

        }




        // const Component = entityMap[entityType][action] || entityMap[entityType].list;

        // console.log('action', action)
        // console.log('Component', Component)

        // Define props based on action type
        const componentProps = {
            setActiveAdminView,
            // ...(action === "update" || action === "delete" ? { id: selectedEntityId } : {}),
            // 07 Mar 2025 ✅ Pass userId and userOrgId if available
            ...(
                action === "update" || 
                action === "delete" ||
                //08 Sep 2026
                action === "view"
            ? {
                id: selectedEntityId,
                ...(userOrgId ? { userOrgId } : {}),
                ...(userId ? { userId } : {}),        
                }
            : {}),
            ...(action === "create"
            ? {
                ...(userOrgId ? { userOrgId } : {}),
                ...(userId ? { userId } : {}),
                }
            : {}),
            ...(action === "" ? {  // ✅ Defaulting to list when action is empty
                onAdd: () => setActiveAdminView(`create${entityType}`),
                onUpdate: (id) => { setSelectedEntityId(id); setActiveAdminView(`update${entityType}`); },
                onDelete: (id) => { setSelectedEntityId(id); setActiveAdminView(`delete${entityType}`); },

                // 08 Sep 2026
                onView:
                    id => {

                    setSelectedEntityId(
                        id
                    )

                    setActiveAdminView(
                        `view${entityType}`
                    )

                },

                setSelectedEntityId,
                ...(userOrgId ? { userOrgId } : {}),
                ...(userId ? { userId } : {}),
            } : {})
        };

        return <Component {...componentProps} />;
    }

    return <div>Select an admin section</div>;
  };

  // 5 - Handle Save Profile - 12 May 2025
  const handleSaveProfile = async () => {
    if (!fullUserInfo?._id) return;
  
    try {
      await updateUser({
        id: fullUserInfo?._id,
        userOrgId:fullUserInfo?.userOrgId?._id || null,
        name: formData.name,
        email: formData.email,
        username: formData.username,
        googleIcalUrl: formData.googleIcalUrl,
        userOrgRole: fullUserInfo?.userOrgRole?._id || null,
        userOrgTitle: fullUserInfo?.userOrgTitle?._id || null,

        // 29 Aug 2026
        googleDocsEnabled: formData.googleDocsEnabled,
       
      }).unwrap();
      setFeedbackMessage("Profile updated successfully.");
      setFeedbackType("success");
      setEditMode(false); // Optional
    //   console.log("✅ Profile updated successfully");
    } catch (err) {
        setFeedbackMessage(err?.data?.message || "Error updating profile");
        setFeedbackType("error");
    }
  };
  
  
  return (
    <div className="flex h-full bg-gray-100 p-4 rounded-lg font-poppins">
        {/* Left Menu Panel */}
        <div className="w-1/4 bg-white p-2 rounded-lg shadow-md overflow-y-auto">
            <div className=' my-2'>
                <p className="text-sm font-bold text-orange-600 mx-1 px-1 mb-1 mt-2">My Profile Menu</p>
            </div>
            
            {/* User Profile Items */}
            {/* 1 - My Details */}
            <div className='border-b mb-1'>
                <div
                    className={`cursor-pointer my-1 px-3 py-2 rounded text-sm ${
                    activeMenuItem === "profile" 
                    ? "bg-orange-100 text-orange-700" 
                    : "text-gray-600 hover:bg-gray-100"
                    // ? 'bg-orange-600 text-white' 
                    // : 'text-orange-600 hover:bg-gray-200'
                    }`}
                    onClick={() => setActiveMenuItem("profile")}
                >
                    My Details
                </div>
            </div>

            {/* 2 - Upload Pic */}
            <div className='border-b mb-1 pb-1'>
                <div
                    className={`cursor-pointer px-3 py-2 rounded text-sm ${
                    activeMenuItem === "photo" ? "bg-orange-100 text-orange-700" : "text-gray-600 hover:bg-gray-100"
                    }`}
                    onClick={() => setActiveMenuItem("photo")}
                >
                    Upload Pic
                </div>
            </div>

            {/* 3 - Subscription Packs - 09 May 2025 */}
            <div className='border-b mb-1 pb-1'>
                <div
                    className={`cursor-pointer px-3 py-2 rounded text-sm font-medium ${
                    activeMenuItem === "packs" ? "bg-orange-100 text-orange-700" : "text-gray-600 hover:bg-gray-100"
                    }`}
                    onClick={() => setActiveMenuItem("packs")}
                >
                    Packs
                </div>
            </div>

            {/* 4 - All User Admin Items */}
            <div className=''>
            {userAdminMenuItems?.map((item, index) => (
                <div key={item.key + index} className='border-b pb-1 p-[1px]'>
                    <div
                    className={`px-3 py-2 rounded-md text-sm cursor-pointer ${
                        activeMenuItem === "userAdmin" && (activeAdminView === item.key || item.subKeys?.includes(activeAdminView))
                        ? "bg-orange-100 text-orange-700"
                        : "text-gray-600 hover:bg-gray-100"
                    }`}
                    onClick={() => {
                        setActiveMenuItem("userAdmin");
                        setActiveAdminView(item.key);
                    }}
                    >
                    <div className="flex justify-start items-center">
                        {/* <p className="text-sm font-bold mr-2">{index + 1}.</p> */}
                        <p className="text-sm">{item.label}</p>
                    </div>
                    </div>
                </div>
            ))}

            </div>

            {/* 5 - User Admin - 360 Imprint Items - 11 May 2025; 06 Jun 2025 - show this only if the user is EtAdmin*/}
            {isAdmin && (
            <div className='pt-1 '>
            {userAdminImprintMenuItems?.map((item, index) => (
                <div key={item.key + index} className='border-b pb-1 p-[1px]'>
                    <div
                    className={`px-3 py-2 rounded-md text-sm cursor-pointer ${
                        activeMenuItem === "userAdminImprint" && (activeAdminView === item.key || item.subKeys?.includes(activeAdminView))
                        ? "bg-orange-100 text-orange-700"
                        : "text-gray-600 hover:bg-gray-100"
                    }`}
                    onClick={() => {
                        setActiveMenuItem("userAdminImprint");
                        setActiveAdminView(item.key);
                    }}
                    >
                    <div className="flex justify-start items-center">
                        {/* <p className="text-sm font-bold mr-2">{index + 1}.</p> */}
                        <p className="text-sm">{item.label}</p>
                    </div>
                    </div>
                </div>
                ))}
            </div>
            )}
        
            {/* 6 - Org Admin Section */}
            {isOrgAdmin && (
                <>
                <div className="my-2">
                    <p className="text-sm font-bold text-orange-600 mx-1 px-1 mb-1 mt-2"> Org Admin</p>
                </div>

                {orgAdminMenuItems?.map((item, index) => (
                <div key={item.key + index} className='border-b p-[1px]'>
                    <div
                    className={`m-1 px-3 py-2 rounded-md text-sm cursor-pointer ${
                        activeMenuItem === "orgAdmin" && (activeAdminView === item.key || item.subKeys?.includes(activeAdminView))
                        ? "bg-orange-100 text-orange-700"
                        : "text-gray-600 hover:bg-gray-100"
                    }`}
                    onClick={() => {
                        setActiveMenuItem("orgAdmin");
                        setActiveAdminView(item.key);
                    }}
                    >
                    <div className="flex justify-start items-center">
                        <p className="text-sm font-bold mr-2">{index + 1}.</p>
                        <p className="text-xs">{item.label}</p>
                    </div>
                    </div>
                </div>
                ))}
                </>
            )}

            {/* 7 - Et Admin Admin-only Items */}
            {isAdmin && (
                <>
                <div className="my-2">
                    <p className="text-sm font-bold text-orange-600 mx-1 px-1 mb-1 mt-2"> Et Admin</p>
                </div>
                
                {adminMenuItems?.map((item, index) => (
                <div key={item.key + index} className='border-b p-[1px]'>
                    <div
                        
                        className={`m-1 px-3 py-2 rounded-md text-sm cursor-pointer  ${
                        activeMenuItem === "manageUsers" && (activeAdminView === item.key || item.subKeys?.includes(activeAdminView))
                            ? "bg-orange-100 text-orange-700"
                            : "text-gray-600 hover:bg-gray-100"
                        }`}
                        onClick={() => {
                        setActiveMenuItem("manageUsers");
                        setActiveAdminView(item.key);
                        }}
                    >
                        <div className="flex justify-start items-center">
                        <p className="text-sm font-bold mr-2">{index + 1}.</p>
                        <p className="text-xs">{item.label}</p>
                        </div>
                    </div>
                </div>
                ))}
                
                </>
            )}

            {/* 8 - Org Leader Section - 26 Jun 2026*/}
            {isOrgLeader && (
                <>
                <div className="my-2">
                    <p className="text-sm font-bold text-orange-600 mx-1 px-1 mb-1 mt-2"> Org Leader</p>
                </div>

                {orgLeaderAdminMenuItems?.map((item, index) => (
                <div key={item.key + index} className='border-b p-[1px]'>
                    <div
                    className={`m-1 px-3 py-2 rounded-md text-sm cursor-pointer ${
                        activeMenuItem === "orgLeader" && (activeAdminView === item.key || item.subKeys?.includes(activeAdminView))
                        ? "bg-orange-100 text-orange-700"
                        : "text-gray-600 hover:bg-gray-100"
                    }`}
                    onClick={() => {
                        setActiveMenuItem("orgLeader");
                        setActiveAdminView(item.key);
                    }}
                    >
                    <div className="flex justify-start items-center">
                        <p className="text-sm font-bold mr-2">{index + 1}.</p>
                        <p className="text-xs">{item.label}</p>
                    </div>
                    </div>
                </div>
                ))}
                </>
            )}

            {/* 9 - Org Igniters Section - 08 Sep 2026 */}

            {isOrgIgniter && (
                <>

                    <div className="my-2">

                        <p className="text-sm font-bold text-orange-600 mx-1 px-1 mb-1 mt-2">
                            Org Igniters
                        </p>

                    </div>

                    {orgIgniterMenuItems
                        ?.map(
                            (
                                item,
                                index
                            ) => (

                                <div
                                    key={
                                        item.key +
                                        index
                                    }
                                    className="border-b p-[1px]"
                                >

                                    <div
                                        className={`m-1 px-3 py-2 rounded-md text-sm cursor-pointer ${
                                            activeMenuItem ===
                                                "orgIgniter" &&
                                            (
                                                activeAdminView ===
                                                    item.key ||
                                                item.subKeys
                                                    ?.includes(
                                                        activeAdminView
                                                    )
                                            )
                                                ? "bg-orange-100 text-orange-700"
                                                : "text-gray-600 hover:bg-gray-100"
                                        }`}
                                        onClick={
                                            () => {

                                                setActiveMenuItem(
                                                    "orgIgniter"
                                                )

                                                setActiveAdminView(
                                                    item.key
                                                )

                                            }
                                        }
                                    >

                                        <div className="flex justify-start items-center">

                                            <p className="text-sm font-bold mr-2">
                                                {index + 1}.
                                            </p>

                                            <p className="text-xs">
                                                {item.label}
                                            </p>

                                        </div>

                                    </div>

                                </div>

                            )
                        )}

                </>
            )}


        </div>

        {/* Right Content Panel */}
        <div className="w-3/4 bg-white p-4 ml-4 rounded-lg shadow-md overflow-y-auto">
            {activeMenuItem === "profile" && (
            <div>
                <div className='flex justify-between items-center m-1 p-1'>
                    <p className="text-lg font-semibold text-gray-700 mb-2 m-1 p-1">My Details</p>
                    <div
                        onClick={() => setEditMode(prev => !prev)}
                        title={editMode ? "Switch to view mode" : "Edit Profile"}
                        className="cursor-pointer hover:text-orange-800 transition-transform transform hover:scale-110"
                    >
                        {editMode ? (
                        <EyeIcon className='h-4 w-4 text-orange-600' />
                        ) : (
                        <PencilSquareIcon className='h-4 w-4 text-orange-600' />
                        )}
                    </div>            
                </div>
                

                <div className="bg-gray-200 m-1 p-1 rounded font-poppins">
                <div className="bg-white p-2 rounded m-1 space-y-2">
                
                {!editMode && (
                <div>
                    {/* Name */}
                    <div className='border-b border-t py-1'>
                        <div className="grid grid-cols-4 justify-start items-center m-1 p-1 bg-gray-100 hover:bg-orange-100 rounded ">
                            <div className='col-span-1'>
                                <p className="text-sm font-bold text-gray-700">Name:</p>
                            </div>
                            <div className='col-span-3'>
                                <p className="text-sm text-gray-700">{formData.name}</p>
                            </div>  
                        </div>
                    </div>
                    
                    {/* Email */}
                    <div className='border-b py-1'>
                        <div className="grid grid-cols-4 justify-start items-center m-1 p-1 bg-gray-100 hover:bg-orange-100 rounded ">
                            <div className='col-span-1'>
                                <p className="text-sm font-bold text-gray-700">Email:</p>
                            </div>
                            <div className='col-span-3'>
                                <p className="text-sm text-gray-700">{formData.email}</p>
                            </div>  
                        </div>
                    </div>
                    

                    {/* Username */}
                    <div className='border-b py-1'>
                        <div className="grid grid-cols-4 justify-start items-center m-1 p-1 bg-gray-100 hover:bg-orange-100 rounded ">
                            <div className='col-span-1'>
                                <p className="text-sm font-bold text-gray-700">Username:</p>
                            </div>
                            <div className='col-span-3'>
                                <p className="text-sm text-gray-700">{formData.username}</p>
                            </div>  
                        </div>
                    </div>
                    
                    {/* Google iCal URL */}
                    <div className='border-b py-1'>
                    <div className="grid grid-cols-4 justify-start items-center m-1 p-1 bg-gray-100 hover:bg-orange-100 rounded relative">
                        <div className='col-span-1'>
                        <p className="text-sm font-bold text-gray-700">Google iCal URL:</p>
                        </div>
                        <div className='col-span-3'>
                        <p className="text-[10px] text-gray-700 break-all pr-6">
                            {isIcalVisible ? (formData.googleIcalUrl || "Not Provided") : "•••••••••"}
                        </p>
                        </div>
                        <button
                        type="button"
                        className="absolute right-3 top-2"
                        onClick={() => setIsIcalVisible(prev => !prev)}
                        >
                        {isIcalVisible ? (
                            <EyeSlashIcon className="h-4 w-4 text-orange-600" />
                        ) : (
                            <EyeIcon className="h-4 w-4 text-orange-600" />
                        )}
                        </button>
                    </div>
                    </div>

                    {/* Google Docs Integration - 29 Aug 2026 */}
                    <div className='border-b py-1'>
                        <div className="grid grid-cols-4 justify-start items-center m-1 p-1 bg-gray-100 hover:bg-orange-100 rounded">
                            <div className='col-span-1'>
                                <p className="text-sm font-bold text-gray-700">
                                    Google Docs Integration:
                                </p>
                            </div>

                            <div className='col-span-3'>
                                <p
                                    className={`text-sm font-semibold ${
                                        formData.googleDocsEnabled
                                            ? "text-green-700"
                                            : "text-gray-500"
                                    }`}
                                >
                                    {formData.googleDocsEnabled
                                        ? "Enabled"
                                        : "Disabled"}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                )}


                {editMode && (    
                    <div>
                        {/* Name */}
                        <div>
                        <label htmlFor="name" className="block text-sm font-bold text-gray-700 px-1 py-2 mt-2">
                            Full Name
                        </label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
                            className="w-full rounded p-2 border border-gray-300"
                        />
                        </div>

                        {/* Email */}
                        <div>
                        <label htmlFor="email" className="block text-sm font-bold text-gray-700 px-1 py-2 mt-2">
                            Email
                        </label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={(e) => setFormData(prev => ({ ...prev, email: e.target.value }))}
                            className="w-full rounded p-2 border border-gray-300"
                        />
                        </div>

                        {/* Username */}
                        <div>
                        <label htmlFor="username" className="block text-sm font-bold text-gray-700 px-1 py-2 mt-2">
                            Username
                        </label>
                        <input
                            type="text"
                            id="username"
                            name="username"
                            value={formData.username}
                            onChange={(e) => setFormData(prev => ({ ...prev, username: e.target.value }))}
                            className="w-full rounded p-2 border border-gray-300"
                        />
                        </div>

                        {/* Google iCal URL */}
                        <div className="relative">
                        <label htmlFor="googleIcalUrl" className="block text-sm font-bold text-gray-700 px-1 py-2 mt-2">
                            Google Calendar iCal URL
                        </label>
                        <input
                            type={isIcalVisible ? "text" : "password"}
                            id="googleIcalUrl"
                            name="googleIcalUrl"
                            value={formData.googleIcalUrl}
                            onChange={(e) => setFormData(prev => ({ ...prev, googleIcalUrl: e.target.value }))}
                            className="w-full rounded p-2 pr-10 border border-gray-300 text-xs"
                        />
                        <button
                            type="button"
                            className="absolute right-3 top-[46px]"
                            onClick={() => setIsIcalVisible(prev => !prev)}
                        >
                            {isIcalVisible ? (
                            <EyeSlashIcon className="h-4 w-4 text-orange-600" />
                            ) : (
                            <EyeIcon className="h-4 w-4 text-orange-600" />
                            )}
                        </button>
                        </div>

                        {/* Google Docs Integration - 29 Aug 2026 */}
                        <div>
                            <label
                                htmlFor="googleDocsEnabled"
                                className="block text-sm font-bold text-gray-700 px-1 py-2 mt-2"
                            >
                                Google Docs Integration
                            </label>

                            <div className="flex items-center justify-between px-3 py-2 rounded border border-gray-300 bg-gray-50">
                                <div>
                                    <p className="text-sm text-gray-700 font-medium">
                                        Enable Google Docs
                                    </p>

                                    <p className="text-[11px] text-gray-500 mt-1">
                                        Allows Trinity to connect and publish content to your Google Docs.
                                    </p>
                                </div>

                                <button
                                    type="button"
                                    id="googleDocsEnabled"
                                    onClick={() =>
                                        setFormData(prev => ({
                                            ...prev,
                                            googleDocsEnabled:
                                                !prev.googleDocsEnabled,
                                        }))
                                    }
                                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                                        formData.googleDocsEnabled
                                            ? "bg-orange-600"
                                            : "bg-gray-300"
                                    }`}
                                >
                                    <span
                                        className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                                            formData.googleDocsEnabled
                                                ? "translate-x-6"
                                                : "translate-x-1"
                                        }`}
                                    />
                                </button>
                            </div>
                        </div>


                        <div id="actions" className="bg-white m-1 px-1 py-3 rounded">

                        {/* ✅ Loader */}
                        {isUpdating && (
                            <div className="flex items-center px-2 py-1">
                            <PulseLoader color="#ea580c" size={8} />
                            <p className="ml-2 text-sm text-orange-600">Saving changes...</p>
                            </div>
                        )}

                        {/* ✅ Update */}
                        <EtBtnFormBasic
                            name={"Update"}
                            type={"create"}
                            handleClick={handleSaveProfile}
                            disabled={!isDirty || isUpdating}
                        />

                        {/* ✅ Clear */}
                        {/* <EtBtnFormBasic
                            name={"Clear"}
                            type={"clear"}
                            handleClick={() =>{
                            setFormData({
                                name: fullUserInfo?.name || "",
                                email: fullUserInfo?.email || "",
                                username: fullUserInfo?.username || "",
                                googleIcalUrl: fullUserInfo?.googleIcalUrl || "",
                            })
                            setEditMode(false)
                            }
                            }
                        /> */}

                        {/* ✅ Cancel */}
                        <EtBtnFormBasic
                            name={"Cancel"}
                            type={"cancel"}
                            handleClick={() =>{
                            setFormData({
                                name: fullUserInfo?.name || "",
                                email: fullUserInfo?.email || "",
                                username: fullUserInfo?.username || "",
                                googleIcalUrl: fullUserInfo?.googleIcalUrl || "",
                                // 29 Aug 2026
                                googleDocsEnabled:!!fullUserInfo?.googleDocsEnabled,
                            })
                            setEditMode(false)
                            }
                            }
                        />
                        {feedbackMessage && (
                            <p
                                className={`text-sm mt-2 px-1 ${
                                feedbackType === "success" ? "text-green-600" : "text-red-600"
                                }`}
                            >
                                {feedbackMessage}
                            </p>
                        )}
                        </div>
                    </div>
                )}


                </div>
                </div>
            </div>
            )}


            {activeMenuItem === "photo" && (
                <div>
                <p className="text-lg font-semibold text-gray-700 m-2 p-2">Upload Your Profile Pic</p>
                {/* <p className="text-sm text-gray-600 italic">Photo upload functionality coming soon.</p> */}
                <EtUserPicUploadInline />
                </div>
            )}

            {activeMenuItem === "packs" && (
            <div className="w-full">
                <EtTrinityUserPacks userId={userId} userOrgId={userOrgId} />
            </div>
            )}

            {activeMenuItem === "userAdmin" && (
                <div className="w-full">
                {renderAdminContent()}
            </div>

            )}

            {isAdmin && activeMenuItem === "userAdminImprint" && (             // 11 May 2025
                <div className="w-full">
                {renderAdminContent()}
            </div>

            )}

            {isAdmin && activeMenuItem === "manageUsers" && (
            <div className="w-full">
                {renderAdminContent()}
            </div>
            )}

            {isOrgAdmin && activeMenuItem === "orgAdmin" && (
            <div className="w-full">
                {renderAdminContent()}
            </div>
            )}

            {isAdmin && activeMenuItem === "orgSettings" && (
                <div>
                <p className="text-lg font-semibold text-gray-700 mb-2">Organization Settings</p>
                <p className="text-sm text-gray-600 italic">Organization config coming soon.</p>
                </div>
            )}

            {/* 26 Jun 2026 */}
            {isOrgLeader && activeMenuItem === "orgLeader" && (
            <div className="w-full">
                {renderAdminContent()}
            </div>
            )}

            {/* 08 Sep 2026 - Org Igniters */}

            {isOrgIgniter &&
                activeMenuItem ===
                "orgIgniter" && (

                <div className="w-full">

                    {renderAdminContent()}

                </div>

            )}

            

        </div>

    </div>

  )
}

export default EtTrinityUserProfile